<ng-container *transloco="let t; read: 'ORDERS_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>
  <ion-content>
    <div class="mt-32-desktop">
      <swiper
        *ngIf="orders"
        [pagination]="{ dynamicBullets: true, dynamicMainBullets: 3 }"
        [slidesPerView]="1.1"
        [centeredSlides]="true"
        [initialSlide]="initialSlide"
      >
        [spaceBetween]="10">
        <ng-container *ngFor="let order of orders.data; last as isLast">
          <ng-template swiperSlide>
            <div class="history-slide">
              <app-order-details [order]="order" (cancelled)="orderCancelled()"></app-order-details>
              <div class="load-more" [class.reverse]="reverseArrow" *ngIf="isLast && orders.hasMore">
                <ion-icon name="arrow-forward-outline"></ion-icon>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </swiper>

      <div class="flex-column" *ngIf="orderDS$ | async as orderDS" [class.center-content]="orderDS.loading || orderDS.error">
        <app-pre-loader *ngIf="orderDS.loading"> </app-pre-loader>

        <app-error-container *ngIf="!orderDS.loading && !!orderDS.error" [errorKey]="orderDS.error.errorKey"> </app-error-container>
        <app-order-details
          *ngIf="!orderDS.loading && !orderDS.error && !!orderDS.data"
          [order]="orderDS.data"
          (cancelled)="orderCancelled()"
        ></app-order-details>
      </div>
    </div>
  </ion-content>
</ng-container>
